import { useWindowDimensions, Platform } from 'react-native';

import { useIsMobileWeb } from './use-is-mobile-web';

export interface DeviceInfo {
	isPhone: boolean;
	isTablet: boolean;
	isDesktop: boolean;
	isLandscape: boolean;
	isPortrait: boolean;
	screenSize: 'small' | 'medium' | 'large' | 'xlarge';
	width: number;
	height: number;
	platform: typeof Platform.OS;
}

/**
 * Comprehensive device detection hook for responsive design
 * @returns DeviceInfo object with device type, orientation, and size information
 */
export const useDeviceInfo = (): DeviceInfo => {
	const { width, height } = useWindowDimensions();
	const isMobileWeb = useIsMobileWeb();
	const isLandscape = width > height;
	const isPortrait = !isLandscape;
	const shorterDimension = Math.min(width, height);

	const isDesktop = Platform.OS === 'web' && !isMobileWeb;
	const isTablet = !isDesktop && shorterDimension >= 768;
	const isPhone = !isDesktop && !isTablet;

	// Screen size categories
	let screenSize: DeviceInfo['screenSize'];
	if (width < 768) {
		screenSize = 'small';
	} else if (width < 1024) {
		screenSize = 'medium';
	} else if (width < 1440) {
		screenSize = 'large';
	} else {
		screenSize = 'xlarge';
	}

	return {
		isPhone,
		isTablet,
		isDesktop,
		isLandscape,
		isPortrait,
		screenSize,
		width,
		height,
		platform: Platform.OS,
	};
};
